module.exports = __webpack_public_path__ + "img/中景艺.dcf6c458.jpg";